module.exports = {
  "version": "0.25.0"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/axios/lib/env/data.js
 ** module id = 238
 ** module chunks = 0
 **/